export const loginError = {
  invalidEntry: "Wrong username or password",
  genericError: "Something went wrong. Please try again. If the error persists contact customer support"
};
